
  document.addEventListener('DOMContentLoaded', () => {    
    function initializeSliders() {
      var IS_Applied = document.querySelector('.media_thubnails_wrapper.media_thubnails_slider.slick-initialized');
  if(!IS_Applied){
  $('.media_main_preview_slider').slick({
    slidesToShow: 1,
    autoplay: false,
    infinite: true,
    slidesToScroll: 1,
    arrows: false,
    // asNavFor: '.media_thubnails_slider'
  });

  $('.media_thubnails_slider').slick({
    slidesToShow: 7,
    slidesToScroll: 1,
    infinite: false,
    vertical: true,
    verticalSwiping: true,
    autoplay: false,
    swipeToSlide: true,
    focusOnSelect: true,
    asNavFor: '.media_main_preview_slider',
    prevArrow: `<button type='button' class='slick-prev pull-left slick_arrow_media'><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,
    nextArrow: `<button type='button' class='slick-next pull-right slick_arrow_media'><svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>`,  
    responsive: [
    {
      breakpoint: 749,
      settings: {
      vertical: false,
        verticalSwiping: false,
         slidesToShow: 3,
          arrows:false
      }
    },
      {
        breakpoint: 480,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          arrows:false
        }
      }
       ]
  });
 var $slider = $(".media_thubnails_slider");

  if ($slider.length) {
    var currentSlide;
    var slidesCount;
    var sliderCounter = document.createElement("div");
    sliderCounter.classList.add("slider__counter");

    var updateSliderCounter = function (slick) {
      currentSlide = slick.slickCurrentSlide() + 1;
      $(sliderCounter).text(currentSlide + " of " + slidesCount + " Images");
    };

    $slider.on("init", function (event, slick) {
      slidesCount = $slider.attr("data-count"); // Set the slidesCount when slider is initialized
      $slider.append(sliderCounter);
      if (slidesCount > 5) {
        updateSliderCounter(slick);
      }
    });
      $slider.on("afterChange", function (event, slick, currentSlide) {
        updateSliderCounter(slick);
      });
    $slider.slick();
  }
  }
}

    // ========================Qty QTYselector ===================
  function  InitializeQuantity(){
var QTYselector = document.querySelectorAll(".icon_quantity_open");
  console.log('QTYselector' , QTYselector);
if (QTYselector) {
      QTYselector.forEach((selector) => {
      selector.addEventListener("click", function () {
        event.preventDefault();
        event.stopPropagation();
        var thisParent = this.closest(".quantity_selector_dropdown");
        thisParent.querySelector("ul").classList.toggle("hidden");
      });
      selector.addEventListener("focusout", function () {
        var thisParent = this.closest(".quantity_selector_dropdown");
        thisParent.querySelector("ul").classList.add("hidden");
      });
    });
}
var QTYITems = document.querySelectorAll(".qty-item_count");
if (QTYITems) {
  QTYITems.forEach((Items) => {
    Items.addEventListener("click", function () {
      event.preventDefault();
      event.stopPropagation();
      var thiSParenet = this.closest(".product-form__quantity");
      thiSParenet.querySelector(".quantity__input").value =
        this.getAttribute("data-value");
      thiSParenet.querySelector(".quantity__input").setAttribute("value", this.getAttribute("data-value"));
      thiSParenet.querySelector("ul").classList.add("hidden");
    });
  });
}
    }
    function initializerProductBtns(){
    var ZoomBtn = document.querySelectorAll('.zoom-image_btn');
    ZoomBtn.forEach((btn) => {
      btn.addEventListener('click' , function(){
    var TagetElemet =  document.querySelector('.media_main_preview_slider  .slick-current.slick-active')
    var ViewBox =  document.querySelector('.wrapper_larger_view_box')
        ViewBox.classList.remove('hidden');
        ViewBox.querySelector('.wrapper_media_large-image').innerHTML = TagetElemet.innerHTML;
        // console.log(TagetElemet)
      })
    })
      
    //   var VRBtn = document.querySelectorAll('.front-vr-image_btn');
    //   if(VRBtn){
    // VRBtn.forEach((btn) => {
    //   btn.addEventListener('click' , function(){
    //   const container = document.querySelector('.media_main_preview_slider .slick-current.slick-active');
    //     if(document.querySelector('.product_media_grid_wapper .vr_text_wrapper')){
    //       document.querySelector('.product_media_grid_wapper .vr_text_wrapper').remove();
    //     }else{
    //        const vrText = document.createElement('div');
    //   vrText.classList.add('vr_text_wrapper');
    //   vrText.innerText = 'Front VR Text';
    //   container.appendChild(vrText);
    //     }
    // })
    // })
    //   }
  //     if(RotateBtn){
  //  var RotateBtn = document.querySelectorAll('.rotate-image_btn');
  //  let RotationValue = 0;
  //   RotateBtn.forEach((btn) => {
  //   btn.addEventListener("click", function () {
  //     var Model = document.querySelector("#magic-360-block");
  //     var ModelOrigonal = document.querySelector("div:has(>.product_media_grid_wapper)");
  //     if (Model) {
  //       Model.classList.toggle('visible_media');
  //       ModelOrigonal.classList.toggle('hidden_media');
  //     } else {
  //       var TagetElemet = document.querySelector(".media_main_preview_wrapper .slick-current.slick-active");
  //       RotationValue += 90;
  //       TagetElemet.style.setProperty("--rotate", RotationValue + "deg");
  //     }
  //   });
  // });
  //     }
    var ClosAllModals = document.querySelectorAll('.close_btn_modle');
    ClosAllModals.forEach((btn) => {
      btn.addEventListener('click' , function(){
    var TagetElemet =  this.closest('.target_modle_wrapper')
        TagetElemet.classList.add('hidden');
      })
    })
    }
    const dataContainer = document.getElementById('card_product_quick_modal');

    function fetchData(productLink) {
      fetch(productLink)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.text(); // Parse the response as text (HTML)
        })
        .then(html => {
          displayData(html);
        })
        .catch(error => {
          console.error('There has been a problem with your fetch operation:', error);
          dataContainer.innerHTML = 'Failed to load content';
        });
    }

    function displayData(html) {
      if (dataContainer) {
        dataContainer.innerHTML = '';
      }
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const content = tempDiv.querySelector('.data_main_product');
      if (content && dataContainer) {
        dataContainer.innerHTML = content.innerHTML;
        dataContainer.closest('.card_product_modale_wrapper').classList.remove('hidden');
          setTimeout(function(){ 
             InitializeQuantity()
            initializerProductBtns();
            initializeSliders();
          },1000);
        
      }
    }

    function initializeEventListeners() {
      
      const cardModalButtons = document.querySelectorAll('.quick_look_btn_card');
      cardModalButtons.forEach(btn => {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          const productLink = this.getAttribute('data-link');
          event.stopPropagation(); 
          fetchData(productLink);
        });
      });
     
      const cardModalCloseButtons = document.querySelectorAll('.modal_closer_btn_product');
      cardModalCloseButtons.forEach(btn => {
        btn.addEventListener('click', function (event) {
          event.stopPropagation(); 
          dataContainer.closest('.card_product_modale_wrapper').classList.add('hidden');
        });
      });

      const cardModalOverlay = document.querySelectorAll('.modal_closer_overlay_product');
      cardModalOverlay.forEach(btn => {
        btn.addEventListener('click', function (event) {
          event.stopPropagation(); 
          dataContainer.closest('.card_product_modale_wrapper').classList.add('hidden');
        });
      });

    }


  

  const observer = new MutationObserver(() => {
   setTimeout(function() {
    console.log('observer');
    initializeEventListeners();
     setTimeout(function(){
        initializerProductBtns();
     },1000)
  if(  document.querySelector('.sorting_perpage_btn')){  document.querySelector('.sorting_perpage_btn').addEventListener('click', function(event){
    event.stopPropagation(); 
    if(this.closest('.perpage_sortings')) { this.closest('.perpage_sortings').classList.toggle('open_drop_down');}
    });
  }
     if(document.querySelector('.boost-sd__filter-product-list')){  observer.observe(document.querySelector('.boost-sd__filter-product-list'), {childList: true,subtree: true}) }
  },2000);
      observer.disconnect();
  });
  observer.observe(document.body, {childList: true,subtree: true});

  });